import { Component, inject, input, output } from '@angular/core';
import { BaseConfigurableComponent } from '@app/base-config.component';
import { CategoriesService } from '@app/services/categories/categories.service';

@Component({
  selector: 'afcu-tile',
  standalone: true,
  imports: [],
  templateUrl: './tile.component.html'
})
export class TileComponent extends BaseConfigurableComponent {
  protected categoriesService = inject( CategoriesService );

  // @Output() filter = new EventEmitter<boolean>();

  filter = output<void>()

  category = input.required<string>()
  services = input.required<number>()

  constructor () {
    super('tile')
  }

  protected categorySelect (val: string) {
    this.categoriesService.searchQuery.set(val)
    this.filter.emit()
  }
}
